import { useQuery } from '@tanstack/react-query';
import endpoints from '../endpoints.ts';
import api from '../api/index.ts';

export const TOOLS_QUERY_KEY = 'TOOLS_QUERY_KEY';

const useUserReadAll = () =>
  useQuery({
    queryKey: [TOOLS_QUERY_KEY, endpoints.tools.user.read.all()],
    queryFn: api.tools.user.read.all,
  });

const tools = {
  useUserReadAll,
};

export default tools;
